export default "__VITE_ASSET__b066ff7f__"